"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.includeAux = exports.include = void 0;
const indent_1 = require("../../utils/indent");
const closure_1 = require("../closure");
const ctx_1 = require("../ctx");
const equivalent_1 = require("../equivalent");
const Errors = __importStar(require("../errors"));
const include_1 = require("../include");
const Neutrals = __importStar(require("../neutral"));
const freshen_1 = require("../utils/freshen");
const Values = __importStar(require("../value"));
/**

   # Subtyping

   We use the word `include` to name our function
   which implements the subtyping relation.

   Comparing it with the word `equivalent`
   for equivalent relation between types.

   `include` is like `equivalent` but applies only to types,
   and also handles subtyping between classes,
   -- simple attribute based subtype relation.

   `equivalent` is implemented by `readback` and `alphaEquivalent`,

   We will not implement `Union` and `Intersection` types.

   We only use tagged union (sum type in ADT),
   -- which will be implemented by our induction datatypes.

**/
function include(mod, ctx, type, subtype) {
    try {
        includeAux(mod, ctx, type, subtype);
    }
    catch (error) {
        if (error instanceof Errors.InclusionError) {
            error.trace.unshift([
                `[include]`,
                (0, indent_1.indent)(`subtype: ${Values.formatType(mod, ctx, subtype)}`),
                (0, indent_1.indent)(`type: ${Values.formatType(mod, ctx, type)}`),
            ].join("\n"));
        }
        throw error;
    }
}
exports.include = include;
function includeAux(mod, ctx, type, subtype) {
    if (subtype["@kind"] === "Pi" && type["@kind"] === "Pi") {
        /**
           Contravariant in argument position.
    
           The order of type and subtype is swapped
           in the following recursive call to `include`.
        **/
        include(mod, ctx, subtype.argType, type.argType);
        const name = subtype.retTypeClosure.name;
        const argType = subtype.argType;
        const usedNames = (0, ctx_1.ctxNames)(ctx);
        const freshName = (0, freshen_1.freshen)(usedNames, name);
        const v = Values.TypedNeutral(argType, Neutrals.Var(freshName));
        ctx = (0, ctx_1.CtxCons)(freshName, argType, ctx);
        include(mod, ctx, (0, closure_1.closureApply)(type.retTypeClosure, v), (0, closure_1.closureApply)(subtype.retTypeClosure, v));
        return;
    }
    if (subtype["@kind"] === "Sigma" && type["@kind"] === "Sigma") {
        include(mod, ctx, type.carType, subtype.carType);
        const name = subtype.cdrTypeClosure.name;
        const carType = subtype.carType;
        const usedNames = (0, ctx_1.ctxNames)(ctx);
        const freshName = (0, freshen_1.freshen)(usedNames, name);
        const v = Values.TypedNeutral(carType, Neutrals.Var(freshName));
        ctx = (0, ctx_1.CtxCons)(freshName, carType, ctx);
        include(mod, ctx, (0, closure_1.closureApply)(type.cdrTypeClosure, v), (0, closure_1.closureApply)(subtype.cdrTypeClosure, v));
        return;
    }
    if (Values.isClazz(subtype) && Values.isClazz(type)) {
        (0, include_1.includeClazz)(mod, ctx, type, subtype);
        return;
    }
    if (subtype["@kind"] === "Equal" && type["@kind"] === "Equal") {
        include(mod, ctx, type.type, subtype.type);
        (0, equivalent_1.equivalent)(mod, ctx, type.type, type.from, subtype.from);
        (0, equivalent_1.equivalent)(mod, ctx, type.type, type.to, subtype.to);
        return;
    }
    (0, equivalent_1.equivalentType)(mod, ctx, type, subtype);
}
exports.includeAux = includeAux;
//# sourceMappingURL=include.js.map